<template>
  <div id="login" style="width: 100%; height: 100%;">
    <div class="box-head">
      <div id="login-ds" class="box-login">
        <p class="lb-welcome">Welcome to</p>
        <p class="lb-project">ABS Dashboard</p>
        <br><br>
        <a-input id="user" ref="user" v-model="username" placeholder="ผู้ใช้งาน" :class="(validate_user == false ? 'br-red' : '')" @keypress="toFocus">
          <a-icon slot="prefix" type="user" />
        </a-input>
        <br><br>
        <a-input-password id="pass" ref="pass" v-model="password" placeholder="รหัสผ่าน" :class="(validate_pass == false ? 'br-red' : '')" @keypress="toFocus">
          <a-icon slot="prefix" type="lock" />
        </a-input-password>
        <br><br>
        <br><br><br>
        <a-button type="primary" shape="round" size="large" @click="fncLogin()" style="background: #222D3A; font-size: 20px; border: none;">
          เข้าสู่ระบบ
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as authService from "../services/auth.service";

export default {
  name: "login",
  components: { },
  data() {
    return {
      isLoading: false,
      username: "",
      password: "",
      validate_user: null,
      validate_pass: null,
      rememberFlag: [],
      sessionUser: []
    };
  },
  mounted() { },
  methods: {
    toFocus: function(e) {
      if (e.keyCode == 13) {
        if (e.target.id == "user") {
          this.$refs.pass.focus();
        } else if (e.target.id == "pass") {
          this.fncLogin(); 
        }
      }
    },
    toPage: function(p) {
      this.$router.push(p);
    },
    fncLogin: async function() {
      var self = this;
      var status = true;
      // ths.isLoading = true;

      if (self.username == "") {
        status = false;
        self.validate_user = false;
      } else {
        status = true;  
        self.validate_user = null;
      }
      
      if (self.password == "") {
        status = false;
        self.validate_pass = false;
      } else {
        status = true;  
        self.validate_pass = null;
      } 
      
      if (status) {

        var auth = window.btoa(self.username + ":" + self.password);

        await authService.getToken(auth).then(response => {
          console.log(response.data);
          if (response.data != null && response.data.accessToken != null && response.data.accessToken != "" && response.data.urlRedirect != undefined && response.data.urlRedirect != null && response.data.urlRedirect != "") {
            localStorage.setItem('token', response.data.accessToken);
            localStorage.setItem('redi', response.data.urlRedirect);
            localStorage.setItem('provinceCode', response.data.provinceCode);
            self.$router.push("/dashboard" + response.data.urlRedirect);
          } else {
            alert("ไม่สำเร็จ !!")
          }
        })
      }

      // ths.isLoading = false;
    },
  }
};
</script>

<style scoped>
  #login {
    min-height: 100%;
    background: #66110C;
  }
  .box-head {
    margin: 0 auto;
    padding: 150px 130px;
    height: 100%;
  }
  .box-login {
    background: #FFF;
    min-height: 300px;
    padding: 60px 80px;
    position: relative;
    color: #222D3A;
    border-radius: 5px;
  }
  .box-login span {
    width: 40%;
    font-size: 26px;
  }
  .logo-login {
    width: 180px; 
    position: absolute; 
    bottom: 40px; 
    right: 50px;
  }
  .lb-welcome {
    font-size: 60px; 
    margin: 0; 
    font-weight: bold; 
  }
  .lb-project {
    font-size: 45px;
    margin: 0;
  }
  @media only screen and (max-width: 1366px) {
    .box-head {
      padding: 95px 130px;
    }
  }
  @media only screen and (max-width: 1270px) {
    .box-head {
      padding: 75px 130px;
    }
  }
  @media only screen and (max-width: 1260px) {
    .box-login span {
      width: 60%;
    }  
  }
  @media only screen and (max-width: 1200px) {
    .box-head {
      padding: 55px 130px;
    }
  }
  @media only screen and (max-width: 1110px) {
    .box-head {
      padding: 35px 130px;
    }
  }
  @media only screen and (max-width: 960px) {
    .box-login span {
      width: 100%;
    }  
    .lb-welcome {
      font-size: 50px; 
    }
    .lb-project {
      font-size: 35px; 
    }
  }
  @media only screen and (max-width: 960px) {
    .box-head {
      padding: 80px;
    }
    .box-login {
      padding: 60px;
    }
    .logo-login {
      width: 140px; 
      bottom: 10px; 
      right: 10px;
    }
    .lb-welcome {
      font-size: 40px; 
    }
    .lb-project {
      font-size: 25px; 
    }
  }
  @media only screen and (max-width: 560px) {
    .box-login {
      padding: 30px;
      text-align: center;
    }
    .logo-login {
      position: relative;
      width: 140px; 
      margin-top: 30px;
    }
  }
  @media only screen and (max-width: 485px) {
    .box-head {
      padding: 30px;
    }
  }
</style>